<template>
    <div class="md-layout md-alignment-center-center">
        <div class="md-layout-item resetContainer">
            <md-card class="resetCard">
                <md-card-header class="md-title">Reset Password</md-card-header>
                <md-card-content>
                    <p class="registerText">We will send you an email to reset your password</p>
                    <md-field>
                        <label>Email address</label>
                        <md-input type="text" v-model.trim="email"></md-input>
                    </md-field>
                </md-card-content>
                <md-card-actions>
                    <md-button class="md-dense md-accent" @click="resetPassword()">Submit</md-button>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

const fb = require('../config.js')

export default {
  name: 'appReset',
  data: function () {
    return {
      email: ''
    }
  },
  methods: {
    ...mapActions(['displayError', 'displayMessage']),
    resetPassword: function () {
      fb.auth.sendPasswordResetEmail(this.email).then(() => {
        this.displayMessage('Email sent.')
        this.email = ''
      }).catch(err => {
        console.log(err)
        this.displayError('Error sending reset email: ' + err.message)
      })
    }
  }
}
</script>

<style lang="scss">

</style>
